import type { SectionAccordionHeaderAction } from "@-/dev.improve.haniverse.components.ui.section-accordion";
import { useDeviceSetting } from "@-/dev.improve.haniverse.lib.device-settings";

/**
 * Header toggles for a section of `SentenceRow`s: whether every sentence shows its pinyin and its
 * translation by default. Global (device) settings; each sentence can still override its own.
 */
export function useSentenceDisplayHeaderActions(): SectionAccordionHeaderAction[] {
  const [isPinyinShownByDefault, setIsPinyinShownByDefault] = useDeviceSetting(
    "sentencePinyinShownByDefault",
  );
  const [isTranslationShownByDefault, setIsTranslationShownByDefault] = useDeviceSetting(
    "sentenceTranslationShownByDefault",
  );
  return [
    {
      iconName: "MsLanguageChinesePinyin",
      label: "Show pinyin by default",
      onPress: () => setIsPinyinShownByDefault(!isPinyinShownByDefault),
      selected: isPinyinShownByDefault,
    },
    {
      iconName: "MdLanguage",
      label: "Show translations by default",
      onPress: () => setIsTranslationShownByDefault(!isTranslationShownByDefault),
      selected: isTranslationShownByDefault,
    },
  ];
}
